import * as t from 'io-ts';
import { id, users } from '@/services/api';
import { filterCodec as groupCodec } from '@/services/api/resources/group';
import { ruleCodec, sendableRuleCodec } from '@/services/api/resources/rrule';

const data = t.type({
  assignees: users,
  assignedGroups: t.array(groupCodec),
  rule: ruleCodec,
});

export const recordCodec = t.type({
  id,
  data,
});

export const formCodec = t.type({
  rule: ruleCodec,
  assignees: t.array(t.union([t.number, t.string])),
  assignedGroups: t.array(t.union([t.number, t.string])),
});

export const detailCodec = t.type({
  data,
});

const sendableUserGroupCodec = t.type({
  users: t.array(t.union([t.number, t.string])),
  groups: t.array(t.union([t.number, t.string])),
});

export const sendableCodec = t.type({
  rule: sendableRuleCodec,
  assignees: sendableUserGroupCodec,
});
